export interface DateRange {
  from: string;
  to: string;
}
